import React from 'react';
import { string, shape, array } from 'prop-types';
import Icon from 'components/icon';

export default function BaseTile({ item }) {
    const tags = [];
    for (let i = 0; i < item.tags.length; i += 1) {
        tags.push(<span>{ item.tags[i] }</span>);
    }

    return (
        <a href={item.url} className="c-event-large-tile">
            <div className="tile-image-wrapper">
                <span className="display-price">{item.price}</span>
                <div className="tile-image">
                    <img src={item.thumbnail} alt="" />
                </div>

                <div className="tile-tag">
                    {tags}
                    <span className="icon">
                        <Icon glyph="share-arrow" />
                    </span>
                </div>
            </div>

            <div className="tile-content">
                <h3 className="title">{item.title}</h3>
                <div className="tile-text">
                    <p>{item.date}<br />{item.time}</p>

                    <p>{item.blurb}</p>
                </div>
            </div>
        </a>
    );
}

BaseTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        title: string.isRequired,
        blurb: string.isRequired,
        date: string.isRequired,
        time: string.isRequired,
        price: string.isRequired,
        tags: array.isRequired,
        thumbnail: string.isRequired
    }).isRequired
    /* eslint-enable react/no-typos */
};
